import classnames from 'consts/classnames';

/**
 * Scroll
 * @description To forbid and restore scrolling on the whole page.
 * Particularly useful for Popup windows.
 *
 * http://stackoverflow.com/questions/28411499/html-css-disable-scrolling-on-body
 */

const { SCROLL_FORBID, SCROLL_FROZEN } = classnames;

export default {
    forbid() {
        /* Save current scroll position */
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        window.pagePrevScrollX = window.pageXOffset;
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        window.pagePrevScrollY = window.pageYOffset;

        document.documentElement.classList.add(SCROLL_FORBID);
        document.body.classList.add(SCROLL_FORBID);
    },

    restore() {
        document.documentElement.classList.remove(SCROLL_FORBID);
        document.body.classList.remove(SCROLL_FORBID);

        /* Restore scroll position to the previous one */
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        window.scrollTo(window.pagePrevScrollX, window.pagePrevScrollY);
    },

    freeze() {
        document.documentElement.classList.add(SCROLL_FROZEN);
    },

    unfreeze() {
        document.documentElement.classList.remove(SCROLL_FROZEN);
    },

    /**
     * Find the current top offset of element
     */
    getOffsetTop(element) {
        const currentScrollPosition =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
        return element.getBoundingClientRect().top + currentScrollPosition;
    },

    /**
     * Scroll to the target element with offset
     */
    toElement({ behavior = 'smooth', callback, customOffset, target }) {
        const targetOffsetTop = this.getOffsetTop(target);
        const top = targetOffsetTop - customOffset;

        window.scroll({
            behavior,
            top
        });

        if (callback) {
            window.onscroll = () => {
                const currentScrollOffset =
                    window.pageYOffset || document.documentElement.scrollTop;

                // Scroll reached the target
                if (currentScrollOffset === top) {
                    window.onscroll = null; // remove listener

                    // call optional callback
                    callback();
                }
            };
        }
    },

    /**
     * Scroll to the target CSS selector with offset
     * @param {String} selector
     * @param {?Number} customOffset - Extra space for the scrolled element position
     * @param {?function} callback - Optional callback when scroll is done
     */
    toSelector(selector, customOffset, callback) {
        const target = document.querySelector(selector);

        if (target) {
            this.toElement({ target, customOffset, callback });
        }
    }
};
